import { Component, OnInit } from "@angular/core";
import { AuthService } from "@shared/auth/auth.service";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";



@Component({
  selector: 'admin',
  templateUrl: './admin.component.html'
})

export class AdminComponent implements OnInit {



  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    private authService: AuthService) { };

  ngOnInit(): void {

  }

  tabVisible(type: string): boolean {
    let reqRole = '';
    switch (type) {
      case 'cliaUpdates':
      case 'registrationLicense':
        {
          reqRole = 'Admin,OfficeAdmin';
          break;
        }
        case 'ptReports':
        case 'pt':
        {
          reqRole = 'Admin,LabTech';
          break;
        }
      case 'masterTables':
        {
          reqRole = 'Admin';
          break;
        }
    }
    let roles = reqRole.split(',');
    return this.authService.userHasAtLeastOneRole(roles);
  }
}


